module.exports = __webpack_public_path__ + "static/img/IOS.700a3bd5.png";